export default __webpack_public_path__ + "static/media/group_element.9973f2a0.svg";